/* eslint-disable no-undef */
import Vue from 'vue'
import './plugins' // local plugins
import './components'
import './views'
import '../shared-components'
import '../shared-report'
import App from './App.vue'
import router from './router'
import store from '@/store'
import vuetify from '@/plugins/vuetify'
// import './registerServiceWorker'
Vue.config.productionTip = process.env.NODE_ENV === 'development'

try {
  // if (ga) {
  //   ga('set', 'page', router.currentRoute.path);
  //   ga('send', 'pageview')

  //   router.afterEach((to) => {
  //     ga('set', 'page', to.path)
  //     ga('send', 'pageview')
  //   })
  // }
  window.dataLayer.push({
    'event': 'virtualPageview',
    'pageUrl': router.currentRoute.path,
    'pageTitle': router.currentRoute.name
    });
  router.afterEach((to) => {
    window.dataLayer.push({
      'event': 'virtualPageview',
      'pageUrl': to.path,
      'pageTitle': to.name
      });
    })
} catch (error) {
  console.error(error)
}

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
